import type { TOC } from '@ember/component/template-only'
import RouteTemplate from 'ember-route-template'
import { QuizScoresHistory } from 'teacher-ui-client/components/giraffe/charts/quiz-scores/history'
import { QuizScoresAverages } from 'teacher-ui-client/components/giraffe/charts/quiz-scores/averages'
import { ReportingDetailedControls } from 'teacher-ui-client/components/reporting/detailed-controls'
import { ExportType } from 'teacher-ui-client/components/reporting/export-select'
import { ReportingNoDataMessageIf } from 'teacher-ui-client/components/reporting/no-data-message-if'
import { ReportingTeacherUiHeader } from 'teacher-ui-client/components/reporting/teacher-ui-header'
import { t } from 'ember-intl'
import type { QuizScoresRexRoute } from 'teacher-ui-client/reporting/ui-scope/rex/quiz-scores/route'
import { not } from 'ember-truth-helpers'
import { array } from '@ember/helper'
import isSubco from 'teacher-ui-client/helpers/is-subco'
import fullGradeName from 'teacher-ui-client/helpers/full-grade-name'

interface Signature {
  model: ModelFor<QuizScoresRexRoute>
}

export const RexQuizScores: TOC<Signature> = <template>
  <ReportingTeacherUiHeader @title={{t "reporting.pageTitles.quizScores"}} />
  <ReportingDetailedControls
    @students={{@model.scopedStudents}}
    @exportOptions={{array ExportType.print}}
    @isDataPresent={{if @model.quizScoresAverages true false}}
    @showScopePicker={{true}}
    @showDatePicker={{true}}
    @studentRouteName="reporting.ui-scope.rex.student-summary"
  />
  <ReportingNoDataMessageIf @on={{not @model.quizScoresAverages}}>
    {{#each @model.quizScoresAverages as |gradeData|}}
      <div
        class="border-dusty-black-50 shadow-dusty-black-100 print:border-dusty-black-200 my-10 h-76 rounded-md border bg-white shadow-md print:rounded-none print:shadow-none"
      >
        <QuizScoresAverages
          @data={{gradeData}}
          @title={{t "reporting.chartTitles.quizScoresAverages"}}
          @grade={{fullGradeName gradeData.grade_position}}
          @tooltip={{t "reporting.tooltips.quizScoresAverages"}}
        />
      </div>
    {{/each}}
    {{#if @model.quizScoresHistory}}
      <div class="my-10">
        <QuizScoresHistory
          @quizScoresHistoryData={{@model.quizScoresHistory}}
          @students={{@model.scopedStudents}}
          @subco={{(isSubco)}}
          @uiScope={{@model.uiScope.scope}}
          @studentRouteName="reporting.ui-scope.rex.student-summary"
          @tooltip={{t "reporting.tooltips.quizScoresHistory"}}
        />
      </div>
    {{/if}}
  </ReportingNoDataMessageIf>
</template>

export default RouteTemplate(RexQuizScores)
